/**
 * DOM-Helper — Reduziert Boilerplate beim DOM-Aufbau.
 * WARUM: Wir nutzen Vanilla JS statt JSX. Diese Helfer machen den Code lesbar.
 */

export function el(tag, props = {}, children = []) {
  const node = document.createElement(tag);

  for (const [key, val] of Object.entries(props)) {
    if (key === 'class')        node.className = val;
    else if (key === 'style')   Object.assign(node.style, val);
    else if (key === 'dataset') Object.assign(node.dataset, val);
    else if (key.startsWith('on') && typeof val === 'function') {
      node.addEventListener(key.slice(2).toLowerCase(), val);
    }
    else if (key === 'html')    node.innerHTML = val;
    else if (val !== null && val !== undefined && val !== false) {
      node.setAttribute(key, val);
    }
  }

  const list = Array.isArray(children) ? children : [children];
  for (const child of list) {
    if (child == null || child === false) continue;
    node.appendChild(child instanceof Node ? child : document.createTextNode(String(child)));
  }

  return node;
}

export const $  = (sel, root = document) => root.querySelector(sel);
export const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];

// Kurz-Helfer für häufige Tags
export const div    = (props, children) => el('div', props, children);
export const span   = (props, children) => el('span', props, children);
export const button = (props, children) => el('button', props, children);
export const h1     = (props, children) => el('h1', props, children);
export const h2     = (props, children) => el('h2', props, children);
export const h3     = (props, children) => el('h3', props, children);
export const p      = (props, children) => el('p', props, children);
export const input  = (props) => el('input', props);
